import React, { memo } from 'react';
import { SkeletonBasic } from "./components/SkeletonBasic";
export var Skeleton = /*#__PURE__*/memo(function (_ref) {
  var className = _ref.className,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Skeleton' : _ref$testName;
  return /*#__PURE__*/React.createElement(SkeletonBasic, {
    className: className,
    testName: testName
  });
});
Skeleton.displayName = Skeleton.name;